export class PilotSignUP {
  public dateOfBirth!: any;
  public passportCountries: string[] = [];
  public selectedFleet: any = {};
  public selectedRank: any = {};
  public hoursOnTypeInRank: string = '';
  public totalHours: string = '';
  public selectedLicence: any = {};
  public selectedLicenceType: any = {};
  public licenceAuthority: any = {};
  public latestAirlineCompany: any = '';
  public lastFlightDate: any = null;
  public otherNonFlyingPosition: string = '';
}
